<template>
  <div id="app">
    <!-- 背景容器 -->
    <div class="box-xk">
      <!-- 黄瓜背景图片 -->
      <div class="background-image"></div>
      
      <!-- 导航栏 -->
      <Navbar />
      
      <!-- 路由视图 -->
      <router-view />
      
      <!-- 下载链接区域 - 只在根路径显示 -->
      <div class="download-section" v-if="$route.path === '/'">
        <h2>App Downloads</h2>
        <div class="download-buttons">
          <a href="/cucumber_detection_1.0_20251013_001253.apk" class="download-btn android-btn" download>
            <i class="fa fa-android" aria-hidden="true"></i>
            <span>Android App</span>
          </a>
          <a href="/cucumber_detection_win.zip" class="download-btn windows-btn" download>
            <i class="fa fa-windows" aria-hidden="true"></i>
            <span>Windows Version</span>
          </a>
        </div>
      </div>

      <!-- 备案信息区域 - 固定在页面底部 -->
      <div class="beian-info">
        <div class="filing-info">
          <!-- ICP备案信息 -->
          <div class="filing-item">
            <span>鲁ICP备2025186811号-2</span>
          </div>
          
          <!-- 公安备案信息 -->
          <div class="filing-item">
            <img src="/备案图标.png" alt="公安备案图标" class="filing-icon">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37060202002134" rel="noreferrer" target="_blank">
              鲁公网安备37060202002134号
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import Navbar from './components/Navbar.vue';

export default {
  components: {
    Navbar,
  },
  setup() {
    let redirectTimer = null;
    const targetUrl = 'https://fengguoheng.online/';
    const sessionRedirectKey = 'hasRedirectedThisSession';
    
    const checkRedirect = () => {
      const hasRedirected = sessionStorage.getItem(sessionRedirectKey);
      
      if (!hasRedirected) {
        redirectToTarget();
        return true;
      }
      return false;
    };
    
    const redirectToTarget = () => {
      console.log(`跳转到目标地址: ${targetUrl}`);
      sessionStorage.setItem(sessionRedirectKey, 'true');
      window.location.href = targetUrl;
    };
    
    onMounted(() => {
      // 如需自动跳转，取消注释
      // checkRedirect();
    });
    
    onUnmounted(() => {
      if (redirectTimer) {
        clearInterval(redirectTimer);
      }
    });
  }
};
</script>

<style>
/* 主容器样式 */
.box-xk {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 黄瓜背景图片样式 */
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/../public/image.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  z-index: 0;
}

/* 下载区域样式 */
.download-section {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 40px 20px;
  background-color: transparent;
  margin: 20px auto;
  max-width: 800px;
}

.download-section h2 {
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 30px;
  font-size: 24px;
}

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.download-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

.android-btn {
  background-color: #3ddc84;
}

.windows-btn {
  background-color: #0078d7;
}

.download-btn i {
  font-size: 20px;
}

/* 备案信息样式 - 固定在底部 */
.beian-info {
  position: relative;
  z-index: 10;
  margin-top: auto;
  padding: 15px 0;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
}

.filing-info {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.filing-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filing-icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.beian-info a {
  color: #ffffff;
  text-decoration: none;
}

.beian-info a:hover {
  text-decoration: underline;
}

/* 确保内容显示在背景上方 */
#app > div > Navbar,
#app > div > router-view {
  position: relative;
  z-index: 10;
}
</style>
    